import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { TrackingService } from '../core/shared/tracking.service';
import { ToastService } from '../core/shared/toast.service';
import { environment } from '../../environments/environment';

@Component({
	selector: 'app-tracking',
	templateUrl: './tracking.component.html',
	styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent implements OnInit, OnDestroy {

	private readonly SUBSCRIPTIONS: Subscription = new Subscription();

	private formID: any = '';

	public loading: boolean = true;
	public config: any = {};
	public logo: string = '';
	public trackingId: string = '';

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private trackingService: TrackingService,
		private spinner: NgxSpinnerService,
		private toastService: ToastService
	) { }

	ngOnInit(): void {
		this.SUBSCRIPTIONS.add(this.route.paramMap.subscribe(async (params: ParamMap) => {
			this.loading = true;
			this.spinner.show();

			this.formID = params.get('formID');

			try {
				if (!!this.formID && this.formID !== '') {
					const response: any = await this.trackingService.getTrackingConfig(this.formID);

					if (response.data != null) {
						this.config = response.data;
						this.logo = `${environment.imagesUrl}${this.config.FormLogo}`;
						document.title = this.config.PageTitle ?? 'Seguimiento';
					} else {
						await this.router.navigateByUrl('not-found');
					}
				} else {
					await this.router.navigateByUrl('not-found');
				}
			} catch (error: any) {
				console.error('Error loading tracking config: ', error);
				await this.router.navigateByUrl('not-found');
			} finally {
				this.spinner.hide();
				this.loading = false;
			}
		}));
	}

	ngOnDestroy(): void {
		this.SUBSCRIPTIONS.unsubscribe();
	}

	public async onSearch(): Promise<void> {
		const id = this.trackingId.trim();

		if (!id)
			return;

		await this.router.navigate(['tracking', this.formID, 'detail', id]);
	}
}
